// extracted by mini-css-extract-plugin
export default {"spacer":"Button_spacer__tzLXd"};